<template>
	<page>
		<module>
			<view-list work-type="17" ref="view" selector :view-config="auth('b_stock_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="仓库">
							<c-select name="warehouse_id" async @search="searchWarehouse"></c-select>
						</m-search-item>
						<m-search-item label="批次号" v-if="systemConfig.batch_stock == 1">
							<c-input name="batch_code"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
					</m-search>
				</template>
				
				<template #operate>
					<c-button v-if="auth('b_stock_export')" v-lock="lock('b_stock_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_stock_export')" v-lock="lock('b_stock_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_stock_export')" v-lock="lock('b_stock_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_stock_export')" v-lock="lock('b_stock_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<!--库存状态-->
				<template #stock_state="{data}">
					<c-state dict="stockStateName" :value="data.stock_state"></c-state>
				</template>
				<!--库存数量-->
				<template #product_count="{data}">
					<strong v-if="data.product_count && data.product_count > 0" style="color: green">{{data.product_count}}</strong>
					<strong v-else-if="data.product_count && data.product_count < 0" style="color: red">{{data.product_count}}</strong>
					<span v-else>{{data.product_count}}</span>
				</template>
				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="2"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('m_stock_record')" v-lock="lock('m_stock_record')" icon="tf-detail" @click="redirectPage(1,data.product_code)">收发明细</c-table-button>
						<c-table-button v-if="auth('m_stock_change_record')" v-lock="lock('m_stock_change_record')" icon="tf-record" @click="redirectPage(2,data.product_code)">变更记录</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
	export default {
		computed: {
			// 获取dictName选项数据
			...mapState(['systemConfig'])
		},
		data() {
			return {
			}
		},
		methods: {
			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			/******页面跳转****/
			redirectPage(type,product_code){
				if (type == 1){//跳转至【库存收发明细】列表
					this.navigateTo(`stock/record?in_product_code=`+product_code);
				}else {//跳转至【库存变更记录】列表
					this.navigateTo(`stock/change/record?in_product_code=`+product_code);
				}
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>